import BenefitItem from '@/components/elements/BenefitItem';
import { Benefit1 } from '@/components/elements/icons/benefit-1';
import { Benefit2 } from '@/components/elements/icons/benefit-2';
import { Benefit3 } from '@/components/elements/icons/benefit-3';
import { Benefit4 } from '@/components/elements/icons/benefit-4';
import { Flex, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';

const LandingBenefits = () => {
  const { t } = useTranslation(`landing`);
  return (
    <Flex id="benefits" className="boxed-container" pb="20" direction="column">
      <Text mb={1} fontSize={[`md`, null, `2xl`]} color="brand.400">
        {t(`landing_benefits.sub_header`)}
      </Text>
      <Heading mb={[16, null, 24]} as="h2" size="2xl">
        {t(`landing_benefits.header`)}
      </Heading>
      <SimpleGrid columns={[1, null, 2, 4]} gap={10}>
        <BenefitItem
          color="brand.500"
          icon={Benefit1}
          title={t(`landing_benefits.benefits.one.title`)}
          description={t(`landing_benefits.benefits.one.description`)}
        />
        <BenefitItem
          color="#f27341"
          icon={Benefit2}
          title={t(`landing_benefits.benefits.two.title`)}
          description={t(`landing_benefits.benefits.two.description`)}
        />
        <BenefitItem
          color="#42cbbe"
          icon={Benefit3}
          title={t(`landing_benefits.benefits.three.title`)}
          description={t(`landing_benefits.benefits.three.description`)}
        />
        <BenefitItem
          color="#48494c"
          icon={Benefit4}
          title={t(`landing_benefits.benefits.four.title`)}
          description={t(`landing_benefits.benefits.four.description`)}
        />
      </SimpleGrid>
    </Flex>
  );
};

export default LandingBenefits;
